import { IMAGE_SIZES } from '../../constants/imageSizes'
import { usePaintStore } from '../../state/paintStore'
import './ImageSizePicker.css'

export function ImageSizePicker() {
  const imageSize = usePaintStore((s) => s.imageSize)
  const setImageSize = usePaintStore((s) => s.setImageSize)

  return (
    <section className="image-size-picker" aria-label="Image size">
      {IMAGE_SIZES.map((size) => (
        <button
          key={size.id}
          type="button"
          className={`image-size-option${imageSize.id === size.id ? ' is-active' : ''}`}
          onClick={() => setImageSize(size.id)}
          aria-label={`${size.label} image`}
          aria-pressed={imageSize.id === size.id}
        >
          <span
            className="image-size-swatch"
            style={{
              width: `${size.scale * 100}%`,
              paddingBottom: `${size.scale * 75}%`,
            }}
          />
          <span className="image-size-label">{size.label}</span>
        </button>
      ))}
    </section>
  )
}
